/**
 * Brand
 */
export enum Brand {
    ORANGE = 'ORANGE',
    SOSH = 'SOSH',
}
